export function getProfile (roundId, userId) {
  return window.axios.get(`dashboards/nps-replica/round/${roundId}/profile`, {
    params: userId ? { user: userId } : {}
  });
}

export function getDashboard (roundId, filters, userId) {
  return window.axios.get(`dashboards/nps-replica/round/${roundId}`, {
    params: Object.assign({}, filters, userId ? { user: userId } : {})
  });
}

export function updateNpsCalification (roundId, npsCalification) {
  return window.axios.put(`dashboards/nps-replica/round/${roundId}/calification`, {
    nps_calification: npsCalification
  });
}



// WEBPACK FOOTER //
// ./src/api/npsReplicaDashboard.js